import { AxiosError, HttpStatusCode } from "axios"

function isUnauthorizedError(error: AxiosError): boolean {
    return error?.response?.status === HttpStatusCode.Unauthorized || error?.status === HttpStatusCode.Unauthorized
}

function isNotFoundError(error: AxiosError): boolean {
    return error?.response?.status === HttpStatusCode.NotFound || error?.status === HttpStatusCode.NotFound
}

function isForbiddenError(error: AxiosError): boolean {
    return error?.response?.status === HttpStatusCode.Forbidden || error?.status === HttpStatusCode.Forbidden
}

function isBadRequestError(error: AxiosError): boolean {
    return error?.response?.status === HttpStatusCode.BadRequest || error?.status === HttpStatusCode.BadRequest
}

function isConflictError(error: AxiosError): boolean {
    return error?.response?.status === HttpStatusCode.Conflict || error?.status === HttpStatusCode.Conflict
}

function isInternalServerError(error: AxiosError): boolean {
    return (
        error?.response?.status === HttpStatusCode.InternalServerError ||
        error?.status === HttpStatusCode.InternalServerError
    )
}

function isTooManyRequestsError(error: AxiosError): boolean {
    return (
        error?.response?.status === HttpStatusCode.TooManyRequests || error?.status === HttpStatusCode.TooManyRequests
    )
}

function isServiceUnavailableError(error: AxiosError): boolean {
    return (
        error?.response?.status === HttpStatusCode.ServiceUnavailable ||
        error?.status === HttpStatusCode.ServiceUnavailable
    )
}

function isGatewayTimeoutError(error: AxiosError): boolean {
    return error?.response?.status === HttpStatusCode.GatewayTimeout || error?.status === HttpStatusCode.GatewayTimeout
}

function isBadGatewayError(error: AxiosError): boolean {
    return error?.response?.status === HttpStatusCode.BadGateway || error?.status === HttpStatusCode.BadGateway
}

function isUnprocessableEntityError(error: AxiosError): boolean {
    return (
        error?.response?.status === HttpStatusCode.UnprocessableEntity ||
        error?.status === HttpStatusCode.UnprocessableEntity
    )
}

function isPreconditionRequiredError(error: AxiosError): boolean {
    return (
        error?.response?.status === HttpStatusCode.PreconditionRequired ||
        error?.status === HttpStatusCode.PreconditionRequired
    )
}

function isNetworkGeneralError(error: AxiosError): boolean {
    return error.code === "ERR_NETWORK"
}

function isNetworkTimeoutError(error: AxiosError): boolean {
    return error.code === "ECONNABORTED"
}
export {
    isUnauthorizedError,
    isNotFoundError,
    isForbiddenError,
    isBadRequestError,
    isConflictError,
    isInternalServerError,
    isTooManyRequestsError,
    isServiceUnavailableError,
    isGatewayTimeoutError,
    isBadGatewayError,
    isUnprocessableEntityError,
    isPreconditionRequiredError,
    isNetworkGeneralError,
    isNetworkTimeoutError
}
